import { BarChart, LineChart, PieChart } from '@mui/x-charts';
import {Box, Stack, Typography, useTheme} from "@mui/material";
import { useState, useEffect } from 'react';
import SystemUserService from "../../../services/SystemUserService";
import CircularProgress from '@mui/material/CircularProgress';
import dayjs from 'dayjs';
import { tokens } from "../../../theme";

const Team = ({provider, timeStart, timeEnd}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [loadingWorkShift, setLoadingWorkShift] = useState(false);
    const [seriesReportWorkShift, setSeriesReportWorkShift] = useState([])

    // const [loadingTransactions, setLoadingTransactions] = useState(false);
    // const [seriesReportTransactions, setSeriesReportTransactions] = useState([])

    // const [loadingTotalUsersService, setLoadingTotalUsersService] = useState(false);
    // const [seriesTotalUsersService, setSeriesTotalUsersService] = useState([])

    // const [loadingTotalPaymentsMonths, setLoadingTotalPaymentsMonths] = useState(false);
    // const [xAxisTotalPaymentsMonths, setxAxisTotalPaymentsMonths] = useState([])
    // const [seriesTotalPaymentsMonths, setSeriesTotalPaymentsMonths] = useState([])

    // const [loadingCountNewUsersMonths, setLoadingCountNewUsersMonths] = useState(false);
    // const [xAxisCountNewUsersMonths, setxAxisCountNewUsersMonths] = useState([])
    // const [seriesCountNewUsersMonths, setSeriesCountNewUsersMonths] = useState([])

    useEffect(() => {
        // handleUpdateAnaliticsStatic()
        handleUpdateAnaliticsPeriod()
    }, [provider]);  

    useEffect(() => {
        handleUpdateAnaliticsPeriod()
    }, [timeStart, timeEnd]);

    const handleUpdateAnaliticsPeriod = () => {    
        const fetcherReportWorkShift = async () => {
            try {
                setLoadingWorkShift(false)
                setSeriesReportWorkShift([])
                const series = []
                const systemUserReportWorkShift = await SystemUserService.getSystemUserReportWorkShift(provider.id, timeStart, timeEnd);
                systemUserReportWorkShift.data.forEach((item, index) => {
                    series.push({ value: item.hours_worked, label: item.system_user_name }) // item.names
                })
                setSeriesReportWorkShift(series)
                setLoadingWorkShift(true)
            } catch (e) {
                console.log(e);
                setLoadingWorkShift(true)     
            }
        }
        // const fetcherReportTransactions = async () => {
        //     try {
        //         setLoadingTransactions(false)
        //         setSeriesReportTransactions([])
        //         const series = []
        //         const billingDiscountTransactions = await BillingService.getBillingDiscountTransactions(billing.billing_id, timeStart, timeEnd);
        //         billingDiscountTransactions.data.forEach((item, index) => {
        //             series.push({ value: item.discount, label: item.description }) // item.names
        //         })
        //         setSeriesReportTransactions(series)
        //         setLoadingTransactions(true)
        //     } catch (e) {
        //         console.log(e);
        //         setLoadingTransactions(true) 
        //     }
        // };
        fetcherReportWorkShift()
        // fetcherReportTransactions()
    }

    // const handleUpdateAnaliticsStatic = () => {    
    //     const fetcherReportTotalUsersService = async () => {
    //         try {
    //             setLoadingTotalUsersService(false)
    //             setSeriesTotalUsersService([])
    //             const series = []
    //             const billingReportTotalUsersService = await BillingService.getBillingReportTotalUsersService(billing.billing_id, timeStart, timeEnd);
    //             billingReportTotalUsersService.data.forEach((item, index) => {
    //                 series.push({ value: item.total, label: item.service_name }) // item.names
    //             })
    //             setSeriesTotalUsersService(series)
    //             setLoadingTotalUsersService(true)
    //         } catch (e) {
    //             console.log(e);
    //             setLoadingTotalUsersService(true)
    //         }
    //     }
    //     const fetcherReportTotalPaymentsMonths = async () => {
    //         try {
    //             setLoadingTotalPaymentsMonths(false)
    //             setSeriesTotalPaymentsMonths([])
    //             const seriesData = []
    //             const xAxisData = []
    //             const billingReportTotalPaymentsMonths = await BillingService.getBillingReportTotalPaymentsMonths(billing.billing_id);
    //             billingReportTotalPaymentsMonths.data.forEach((item, index) => {
    //                 xAxisData.push(item.month_year) // item.names
    //                 seriesData.push(item.payment) // item.names
    //             })
    //             setSeriesTotalPaymentsMonths(seriesData)
    //             setxAxisTotalPaymentsMonths(xAxisData)
    //             setLoadingTotalPaymentsMonths(true)
    //         } catch (e) {
    //             console.log(e);
    //             setLoadingTotalPaymentsMonths(true)
    //         }
    //     }
    //     const fetcherCountNewUsersMonths = async () => {
    //         try {
    //             setLoadingCountNewUsersMonths(false)
    //             setSeriesCountNewUsersMonths([])
    //             setxAxisCountNewUsersMonths([])
    //             const seriesData = []
    //             const xAxisData = []
    //             const billingReportCountNewUsersMonths = await BillingService.getBillingReportCountNewUsersMonths(billing.billing_id);
    //             billingReportCountNewUsersMonths.data.forEach((item, index) => {
    //                 xAxisData.push(item.month_year) // item.names
    //                 seriesData.push(item.count) // item.names
    //             })
    //             setSeriesCountNewUsersMonths(seriesData)
    //             setxAxisCountNewUsersMonths(xAxisData)
    //             setLoadingCountNewUsersMonths(true)
    //         } catch (e) {
    //             console.log(e);
    //             setLoadingCountNewUsersMonths(true)
    //         }
    //     };
    //     fetcherReportTotalUsersService()
    //     fetcherReportTotalPaymentsMonths()
    //     fetcherCountNewUsersMonths()
    // }

    // function valueFormatter(value) {
    //     return `${value.toFixed(2)} ₽`;
    // }

    return (
        <Stack p={1}>
            {/* <Typography variant='h5' color={colors.greenAccent[400]}>{billing.description}</Typography> */}
            <Stack
                direction="row"
                spacing={{ xs: 1, sm: 2 }}
                useFlexGap
                // width={"100%"}
                // height={"100%"}
                sx={{ flexWrap: 'wrap', p: 2}}
                justifyContent={'center'}
            >
                {/* Team */}
                <Stack spacing={1} width={"30%"} minWidth={"320px"}>
                    <Typography variant='h3' sx={{textAlign: 'center'}}>Team</Typography>
                    <Typography variant='subtitle2' sx={{textAlign: 'center'}}>
                        {dayjs.unix(timeStart).format('YYYY-MM-DD HH:mm:ss')} - {dayjs.unix(timeEnd).format('YYYY-MM-DD HH:mm:ss')}
                    </Typography>
                    {loadingWorkShift
                        ?   <PieChart
                                // title='HJHJHJHJ' подсказка
                                margin={{ top: 0, bottom: 0, left: 0, right:0 }}
                                series={[
                                    {
                                    data: seriesReportWorkShift,
                                    innerRadius: 30,
                                    outerRadius: 100,
                                    paddingAngle: 5,
                                    cornerRadius: 5,
                                    startAngle: -45,
                                    endAngle: 225,
                                    cx: 150,
                                    cy: 150,
                                    }
                                ]}
                                // width={500}
                                height={400}
                                slotProps={{
                                    legend: {
                                        direction: 'row',
                                        position: { vertical: 'bottom', horizontal: 'right' },
                                        padding: 0,
                                    },
                                }}
                            />
                        :   <Box sx={{display: 'flex', justifyContent: 'center', p: 3 }}>
                                <CircularProgress color="primary" />
                            </Box>
                    }       
                    
                </Stack>
                {/* End team */}
                
            </Stack>
        </Stack>
    )};

export default Team;